import React from 'react';
import {Outlet} from 'react-router-dom';
import {ConfirmProvider} from "material-ui-confirm";
import {useIntl} from "react-intl";

const BaseLayout: React.FC = () => {
    const intl = useIntl();

    return (
        <ConfirmProvider defaultOptions={{
            confirmationText: intl.formatMessage({id: 'COMMON_OK'}),
            cancellationText: intl.formatMessage({id: 'COMMON_CANCEL'})
        }}>
            <Outlet/>
        </ConfirmProvider>
    );
};

export default BaseLayout;